import { Map, List, fromJS } from "immutable";

export function getSuperType(type, templates) {
  //console.log("getSuperType " + type);
  let template = templates.get(type);
  //console.log("getSuperType " + type + " temp: " + template);
  if (template) {
    let parentType = template.get("parentType");
    if (parentType) {
      return getSuperType(parentType, templates);
    } else {
      return type;
    }
  }
}

export function getStateTrees(specs, states) {
  function getTypeTree(specs, rootTypeId) {
    let state = specs.get(rootTypeId);
    let newState = state;
    if (state.get("children"))
      newState = state.set(
        "children",
        state.get("children").reduce((acc, child) => {
          return acc.set(child, getTypeTree(specs, child));
        }, new Map())
      );
    return newState;
  }
  let stateTrees;
  if (states)
    stateTrees = states.reduce((acc, state) => {
      return acc.set(
        state.get("id"),
        state.set("type", getTypeTree(specs, state.get("type")))
      );
    }, new Map());
  return stateTrees;
}



// WEBPACK FOOTER //
// ./src/components/TypeHelper.js